import { useQuery } from 'react-query'
import client from '../client'

export default async function getPhotoDictionary(searchWord: string, ctgrNos?: string) {
  let params
  if (ctgrNos) {
    params = {
      searchWord: searchWord,
      ctgrNos: ctgrNos,
      requestApi: 'photoUri',
    }
  } else {
    params = {
      searchWord: searchWord,
      requestApi: 'photoUri',
    }
  }

  const response = await client.post<any>(`/api/search`, params)

  var photoDictCnt
  var photoDictContents

  // 좀 복잡해서 그냥 복붙함
  if (response.data.hasOwnProperty('result')) {
    var resultObjectMap = response.data.result.map
    if (resultObjectMap.hasOwnProperty('RESP_RESULT')) {
      var RESP_RESULT = resultObjectMap.RESP_RESULT.map
      if (RESP_RESULT.hasOwnProperty('PHOTOLIB')) {
        photoDictCnt = Number(RESP_RESULT.PHOTOLIB.map.SEARCH_CNT)
        photoDictContents = RESP_RESULT.PHOTOLIB.map.SEARCH_PHOTOLIB_CONTENTS.myArrayList
      }
    }
  }
  return { photoDictCnt, photoDictContents }
}

// 리액트 쿼리
export function getPhotoDictionaryQuery(searchWord: string, ctgrNos?: string) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data, isLoading, isError } = useQuery<any>(
    getPhotoDictionaryQuery.createKey(searchWord, ctgrNos),
    () => getPhotoDictionary(searchWord, ctgrNos),
    {
      refetchOnWindowFocus: false,
      // staleTime: 1000 * 60 * 5,
    }
  )
  return { data, isLoading, isError }
}

getPhotoDictionaryQuery.createKey = (searchWord: string, ctgrNos?: string) => [
  'photoDict',
  searchWord,
  ctgrNos,
]
